export default __webpack_public_path__ + "static/media/office2.6c99f091.png";